// ── IP 관리 — IP 별칭 설정 섹션 컴포넌트 ─────────────────────────────────────
import React from 'react';
import {
  cardStyle, mobileCardListStyle, mobileCardStyle, mobileCardHeadStyle,
  miniBadgeStyle, mobileActionGridStyle, mobileCodeStyle,
  aliasRowStyle, aliasActionWrapStyle, aliasInputStyle, inputStyle,
  primaryBtn, dangerBtn,
} from './styles';
import { normalizeIp } from './utils';

/**
 * IP 별칭 설정 섹션
 * Props:
 *   isMobile           — 모바일 여부
 *   uniqueAliasRows    — 중복 제거된 별칭 행 목록
 *   aliasDraftByIp     — ip → 별칭 입력 드래프트
 *   aliasBusyIp        — 별칭 저장 중인 IP ('' 이면 없음)
 *   aliasDeleteBusyIp  — 별칭 삭제 중인 IP
 *   onAliasChange      — 별칭 입력 변경 콜백 (ip, value) => void
 *   onSaveAlias        — 별칭 저장 콜백 (ip) => void
 *   onRemoveAlias      — 별칭 삭제 콜백 (ip) => void
 */
export function IpAliasSection({
  isMobile, uniqueAliasRows, aliasDraftByIp,
  aliasBusyIp, aliasDeleteBusyIp,
  onAliasChange, onSaveAlias, onRemoveAlias,
}) {
  return (
    <div style={{ ...cardStyle, marginTop: 14 }}>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>IP 별칭 설정</div>
      <div style={{ color: 'var(--text-muted)', marginBottom: 8, fontSize: 12 }}>
        별칭은 설명과 별개이며, 연결 항목을 삭제해도 별칭 목록은 유지됩니다. 빈 값으로 저장하면 별칭만 비워집니다.
      </div>

      {uniqueAliasRows.length === 0 ? (
        <div style={{ color: 'var(--text-muted)' }}>등록된 별칭이 없습니다.</div>
      ) : isMobile ? (
        /* 모바일 카드 */
        <div style={mobileCardListStyle}>
          {uniqueAliasRows.map((row) => {
            const ip = normalizeIp(row.ip_address);
            return (
              <article key={`alias-${ip}`} style={mobileCardStyle}>
                <div style={mobileCardHeadStyle}>
                  <code style={mobileCodeStyle}>{ip}</code>
                  <span style={miniBadgeStyle}>연결 {Number(row.linked_count || 0)}건</span>
                </div>
                <div style={{ color: 'var(--text-muted)', fontSize: 12, marginBottom: 8 }}>
                  활성 연결 {Number(row.active_linked_count || 0)}건
                </div>
                <input style={inputStyle}
                  value={aliasDraftByIp[ip] ?? ''}
                  placeholder="별칭 없음"
                  onChange={(e) => onAliasChange(ip, e.target.value)}
                />
                <div style={{ ...mobileActionGridStyle, marginTop: 8 }}>
                  <button style={primaryBtn} disabled={aliasBusyIp === ip} onClick={() => onSaveAlias(ip)}>
                    {aliasBusyIp === ip ? '저장 중...' : '저장'}
                  </button>
                  <button style={dangerBtn} disabled={aliasDeleteBusyIp === ip} onClick={() => onRemoveAlias(ip)}>
                    {aliasDeleteBusyIp === ip ? '삭제 중...' : '삭제'}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      ) : (
        /* 데스크톱 그리드 */
        <div style={{ display: 'grid', gap: 8 }}>
          {uniqueAliasRows.map((row) => {
            const ip = normalizeIp(row.ip_address);
            return (
              <div key={`alias-${ip}`} style={aliasRowStyle}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700, overflowWrap: 'anywhere' }}>{ip}</div>
                  <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>
                    연결 {Number(row.linked_count || 0)}건 / 활성 {Number(row.active_linked_count || 0)}건
                  </div>
                </div>
                <input style={aliasInputStyle}
                  value={aliasDraftByIp[ip] ?? ''}
                  placeholder="별칭 없음"
                  onChange={(e) => onAliasChange(ip, e.target.value)}
                />
                <div style={aliasActionWrapStyle}>
                  <button style={primaryBtn} disabled={aliasBusyIp === ip} onClick={() => onSaveAlias(ip)}>
                    {aliasBusyIp === ip ? '저장 중' : '저장'}
                  </button>
                  <button style={dangerBtn} disabled={aliasDeleteBusyIp === ip} onClick={() => onRemoveAlias(ip)}>
                    {aliasDeleteBusyIp === ip ? '삭제 중' : '삭제'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
